import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import DescriptionDate from '../../components/inputs/DescriptionDate.jsx'
import SafeHTML from '../../components/SafeHTML.jsx'

class QuestionDateSelect extends React.Component {
  constructor (props) {
    super(props)
  }

  generateDate() {
    const {onChange, value} = this.props
    return (
      <div className='col-sm-4 question-description-input'>
        <DescriptionDate
          onChange={value => {
            onChange(value)
          }}
          value={value}
        />
      </div>
    )
  }

  render () {
    const { question, error } = this.props
    const formClasses = classNames({
      'form-group': question.question_style === 'dropdown',
      'form-group--radio': question.question_style === 'radio_buttons',
      'has-error': error
    })
    const rowClasses = classNames({
      'has-quality-abbreviation': question.abbreviation === 29,
      'life-critical': question.is_life_critical && question.control_question_id === null,
      'row': true
    })
    return (
      <div className={rowClasses}>
        <div className='col-md-12'>
          <SafeHTML markdown={question.text} />
        </div>
        <div className='col-md-12'>
          {this.generateDate()}
          <div className={formClasses}>
          </div>
        </div>
      </div>
    )
  }
}

QuestionDateSelect.propTypes = {
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  question: PropTypes.object.isRequired,
  fields: PropTypes.object,
  validate: PropTypes.func,
}

export default QuestionDateSelect
